<!-- eslint-disable vue/no-template-shadow -->
<template>
  <div>
    <v-card-text>
      <v-row>
        <v-spacer></v-spacer>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="itemsPerPage"
            :label="$t('lbl.itemsPerPage')"
            type="number"
            min="5"
            hide-details
            dense
            outlined
            @input="changeCantItems()"
          ></v-text-field>
        </v-col>

        <!--<v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="search"
            :append-icon="icons.mdiMagnify"
            :label="$t('btn.search')"
            single-line
            hide-details
            dense
            outlined
            @input="getReservas()"
          ></v-text-field>
        </v-col>-->
      </v-row>
    </v-card-text>

    <v-divider></v-divider>
    <v-form class="multi-col-validation px-5 py-5">
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <strong>{{ pos === 0 ? $t('lbl.reserveFrom') : $t('lbl.cotizationFrom') }}</strong>
          <v-menu
            v-model="menuFromReserve"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedFromReserveDateFormatted"
                :label="pos === 0 ? $t('lbl.reserveHome') : $t('lbl.reserveHome')"
                persistent-hint
                class="pt-2"
                readonly
                v-bind="attrs"
                outlined
                dense
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="search.dateReserveFrom"
              no-title
              locale="es"
              :show-current="false"
              @input="menuFromReserve = false"
            ></v-date-picker>
          </v-menu>
          <!--<vc-date-picker
            v-model="search.dateReserveFrom"
            outlined
            dense
            hide-details
            :max-date="new Date()"
            mode="date"
            :model-config="modelConfig"
            class="pt-2"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <v-text-field
                :label="$t('lbl.dateReserveFrom')"
                outlined
                dense
                :value="inputValue"
                class="pt-2"
                v-on="inputEvents"
              >
              </v-text-field>
            </template>
          </vc-date-picker>-->
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <strong>{{ pos === 0 ? $t('lbl.reserveTo') : $t('lbl.cotizationTo') }}</strong>
          <v-menu
            v-model="menuToReserve"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedToReserveDateFormatted"
                :label="pos === 0 ? $t('lbl.reserveEnd') : $t('lbl.reserveEnd')"
                persistent-hint
                class="pt-2"
                readonly
                v-bind="attrs"
                outlined
                dense
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="search.dateReserveTo"
              no-title
              :max="new Date(Date.now()).toISOString().substr(0, 10)"
              locale="es"
              :show-current="false"
              @input="menuToReserve = false"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.serviceFrom') }}</strong>
          <v-menu
            v-model="menuFromService"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedFromServiceDateFormatted"
                :label="$t('lbl.homeService')"
                persistent-hint
                class="pt-2"
                readonly
                v-bind="attrs"
                outlined
                dense
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="search.dateServiceFrom"
              no-title
              locale="es"
              :show-current="false"
              @input="menuFromService = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.serviceTo') }}</strong>
          <v-menu
            v-model="menuToService"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedToServiceDateFormatted"
                :label="$t('lbl.endService')"
                persistent-hint
                class="pt-2"
                readonly
                v-bind="attrs"
                outlined
                dense
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="search.dateServiceTo"
              no-title
              locale="es"
              :show-current="false"
              @input="menuToService = false"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.typeProduct') }}</strong>
          <v-select
            v-model="search.tipo_product"
            :items="tipos_product"
            :label="$t('lbl.product')"
            outlined
            dense
            hide-details
            item-text="name"
            item-value="entity"
            class="pt-2"
          ></v-select>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.nameViajero') }}</strong>
          <!--<v-autocomplete
            v-model="search.fullName"
            :items="namesTraver"
            :search-input.sync="searchNameTraver"
            hide-details
            hide-selected
            :label="$t('lbl.client')"
            outlined
            dense
            item-text="name"
            item-value="noDocument"
            class="pt-2"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ $t('lbl.client') }}
                </v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item }">
              <span v-text="item.name"></span>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>-->
          <v-text-field
            v-model="search.fullName"
            :label="$t('lbl.client')"
            hide-details
            dense
            outlined
            class="pt-2"
          ></v-text-field>
        </v-col>
        <v-col
          v-if="user.nivel <= 0"
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.afiliate') }}</strong>
          <v-autocomplete
            v-model="search.afiliate"
            :items="afiliados"
            :search-input.sync="afiliadosSearch"
            hide-details
            hide-selected
            :label="$t('lbl.afiliateAgency')"
            outlined
            dense
            item-text="name"
            item-value="id"
            class="pt-2"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ $t('lbl.afiliateAgency') }}
                </v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item }">
              <span v-text="item.name"></span>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.vendedor') }}</strong>
          <v-autocomplete
            v-model="search.seller"
            :items="seller"
            :search-input.sync="sellerSearch"
            hide-details
            hide-selected
            :label="$t('lbl.vendedor')"
            outlined
            dense
            item-text="name"
            item-value="id"
            class="pt-2"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ $t('lbl.vendedor') }}
                </v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item }">
              <span v-text="item.name"></span>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <strong>{{ pos === 0 ? $t('lbl.codeReserva') : $t('lbl.codeCotization') }}</strong>
          <v-autocomplete
            v-model="search.codeReserva"
            :items="codesReserva"
            :search-input.sync="searchCodeReserva"
            hide-details
            hide-selected
            :label="$t('lbl.code')"
            outlined
            dense
            class="pt-2"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ $t('lbl.code') }}
                </v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item }">
              <span v-text="item"></span>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <strong>{{ pos === 0 ? $t('lbl.stateReserva') : $t('lbl.stateCotization') }}</strong>
          <v-select
            v-model="search.state"
            :items="states"
            :label="$t('lbl.state')"
            outlined
            dense
            hide-details
            item-text="name"
            item-value="id"
            class="pt-2"
          ></v-select>
        </v-col>
      </v-row>
    </v-form>
    <v-divider></v-divider>
    <v-form class="multi-col-validation px-5 py-5">
      <v-row>
        <v-col
          cols="12"
          md="1"
        >
          <v-btn
            v-if="
              search.tipo_product ||
                search.fullName ||
                search.codeReserva ||
                search.state ||
                search.dateReserveFrom ||
                search.dateReserveTo ||
                search.dateServiceFrom ||
                search.dateServiceTo ||
                search.afiliate ||
                search.seller
            "
            class="mx-2"
            fab
            outlined
            small
            color="error"
            @click="clearSearch()"
          >
            <v-icon small>
              {{ icons.mdiEraserVariant }}
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          md="9"
          class="text-center"
        >
          <v-btn
            :loading="loading"
            color="primary"
            @click="
              loading = true
              getReservas()
              getCotizations()
            "
          >
            <v-icon
              right
              dark
            >
              {{ icons.mdiMagnify }}
            </v-icon>
            <span class="pl-5">{{ $t('btn.search') }}</span>
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          md="2"
          class="text-lowercase"
        >
          <span v-if="pos === 0"> {{ totalF }} {{ $t('lbl.de') }} {{ totalItems }} {{ $t('menu.reservas') }} </span>
          <span v-if="pos === 1">
            {{ totalFCotization }} {{ $t('lbl.de') }} {{ totalItemsCotization }} {{ $t('menu.cotizations') }}
          </span>
        </v-col>
      </v-row>
    </v-form>

    <v-tabs v-model="pos">
      <v-tab>
        {{ $t('menu.reservas') }}
      </v-tab>
      <v-tab>
        {{ $t('menu.cotizations') }}
      </v-tab>
    </v-tabs>

    <v-divider></v-divider>

    <v-tabs-items v-model="pos">
      <v-tab-item @click="setPosCotizador(0)">
        <Reservas
          :user="user"
          :reservas="reservas"
          :states="states"
          :tipos_product="tipos_product"
          :names="names"
          :codes="codes"
          @loadAll="initAll()"
        />
      </v-tab-item>
      <v-tab-item @click="setPosCotizador(1)">
        <Cotizations
          :user="user"
          :cotizations="cotizations"
          :states="states"
          :tipos_product="tipos_product"
          :names="names"
          :codes="codes"
          @loadAll="initAll()"
        />
      </v-tab-item>
    </v-tabs-items>

    <v-card-text class="pt-2">
      <v-row>
        <v-col
          lg="12"
          cols="12"
          class="d-flex justify-end"
        >
          <v-pagination
            v-if="pos === 0"
            v-model="pagination.current"
            :length="pagination.total"
            total-visible="5"
            @input="onPageChange"
          ></v-pagination>
          <v-pagination
            v-if="pos === 1"
            v-model="paginationCotization.current"
            :length="paginationCotization.total"
            total-visible="5"
            @input="onPageChange"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import {
  mdiMagnify,
  mdiDeleteOutline,
  mdiSquareEditOutline,
  mdiPlus,
  mdiArrowLeft,
  mdiUpdate,
  mdiFormatListText,
  mdiAirplaneTakeoff,
  mdiCar,
  mdiBed,
  mdiClose,
  mdiEye,
  mdiEraserVariant,
} from '@mdi/js'

// eslint-disable-next-line import/no-unresolved
import useAppConfig from '@core/@app-config/useAppConfig'
import Reservas from '../tabs/Reservas.vue'
import Cotizations from '../tabs/Cotizations.vue'

export default {
  setup() {
    const { menuIsVerticalNavMini } = useAppConfig()

    return {
      menuIsVerticalNavMini,
    }
  },
  components: {
    Reservas,
    Cotizations,
  },
  data() {
    return {
      currentTab: 0,
      isLoading: true,
      openFiltros: false,
      search: {
        proximas: false,
        activas: false,
        state: null,
      },
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
        wheelSpeed: 0.7,
      },
      reservas: [],
      pagination: {
        current: 1,
        total: 0,
      },
      totalItems: 0,
      totalF: 0,
      cotizations: [],
      paginationCotization: {
        current: 1,
        total: 0,
      },
      totalItemsCotization: 0,
      totalFCotization: 0,
      itemsPerPage: 10,
      icons: {
        mdiMagnify,
        mdiDeleteOutline,
        mdiSquareEditOutline,
        mdiPlus,
        mdiArrowLeft,
        mdiUpdate,
        mdiFormatListText,
        mdiAirplaneTakeoff,
        mdiCar,
        mdiBed,
        mdiClose,
        mdiEye,
        mdiEraserVariant,
      },
      isDialogVisible: false,
      isDialogVisibleDelete: false,
      item: {},
      itemId: null,
      abilities: [],
      abilityList: [],
      states: [],
      checkPermiso: 1,
      loading: false,
      permisos: sessionStorage.getItem('permisos_auth'),
      is_nivel_propietario: false,
      user: {},
      tipos_product: [],
      names: [],
      namesTraver: [],
      searchNameTraver: null,
      codes: [],
      codesReserva: [],
      searchCodeReserva: null,
      afiliadosList: [],
      afiliados: [],
      afiliadosSearch: null,
      sellerList: [],
      seller: [],
      sellerSearch: null,
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
      menuFromReserve: false,
      menuToReserve: false,
      menuFromService: false,
      menuToService: false,
      pos: 0,
    }
  },
  computed: {
    ...mapState({
      posCotizador: state => state.app.posCotizador,
    }),
    computedFromReserveDateFormatted() {
      return this.search.dateReserveFrom ? this.$moment(this.search.dateReserveFrom).format('D-MMM-YY') : ''
    },
    computedToReserveDateFormatted() {
      return this.search.dateReserveTo ? this.$moment(this.search.dateReserveTo).format('D-MMM-YY') : ''
    },
    computedFromServiceDateFormatted() {
      return this.search.dateServiceFrom ? this.$moment(this.search.dateServiceFrom).format('D-MMM-YY') : ''
    },
    computedToServiceDateFormatted() {
      return this.search.dateServiceTo ? this.$moment(this.search.dateServiceTo).format('D-MMM-YY') : ''
    },
  },
  watch: {
    searchNameTraver(val) {
      if (val.length > 0) {
        // eslint-disable-next-line no-unused-expressions
        val && this.filterNameTraver(val.toLowerCase())
      } else {
        this.namesTraver = []
      }
    },
    searchCodeReserva(val) {
      if (val.length > 0) {
        // eslint-disable-next-line no-unused-expressions
        val && this.filterCodeReserva(val.toLowerCase())
      } else {
        this.codesReserva = []
      }
    },

    afiliadosSearch(val) {
      if (val.length > 0) {
        // eslint-disable-next-line no-unused-expressions
        val && this.filterAfiliados(val.toLowerCase())
      } else {
        this.afiliados = []
      }
    },
    sellerSearch(val) {
      if (val.length > 0) {
        // eslint-disable-next-line no-unused-expressions
        val && this.filterSeller(val.toLowerCase())
      } else {
        this.seller = []
      }
    },
  },
  mounted() {
    // PARA Q NAZCA EL MENU IZQ OCULTO
    this.menuIsVerticalNavMini = true
    this.pos = this.posCotizador
  },
  created() {
    this.profile()
    this.initAll()

    this.getStates()
    this.getTiposProduct()
    this.getNamesClient()
    this.getCodesReservas()
    this.getAfiliados()
    this.getSeller()
  },
  methods: {
    ...mapMutations(['setPosCotizador']),
    filterNameTraver(v) {
      this.namesTraver = []
      if (v === '') {
        this.namesTraver = []
      } else {
        this.namesTraver = this.names.filter(e => e.name.toLowerCase())
      }
    },
    filterCodeReserva(v) {
      this.codesReserva = []
      if (v === '') {
        this.codesReserva = []
      } else {
        this.codesReserva = this.codes.filter(e => e.toLowerCase())
      }
    },
    filterAfiliados(v) {
      this.afiliados = []
      if (v === '') {
        this.afiliados = []
      } else {
        this.afiliados = this.afiliadosList.filter(e => e.name.toLowerCase())
      }
    },
    filterSeller(v) {
      this.seller = []
      if (v === '') {
        this.seller = []
      } else {
        this.seller = this.sellerList.filter(e => e.name.toLowerCase())
      }
    },
    profile() {
      this.axios
        .get(`${process.env.VUE_APP_API_URL}profile`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(response => {
          // eslint-disable-next-line no-empty
          if (response.data.success === false) {
          } else if (response.data.data.nivel === -1) {
            this.is_nivel_propietario = true
          }
          this.user = response.data.data
        })
        .catch(error => console.log(error))
        // eslint-disable-next-line no-return-assign
        .finally(() => (this.isLoading = false))
    },
    getStates() {
      this.axios
        .get('state_reservations?per_page=10000', {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          this.states = res.data.data
        })
    },
    getTiposProduct() {
      this.axios
        .get('type_product?per_page=10000', {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          const result = res.data.data
          result.forEach(element => {
            if (
              element.entity !== 'transfers'
              && element.entity !== 'excursions'
              && element.entity !== 'packages'
              && element.entity !== 'cruise_ships'
            ) {
              this.tipos_product.push(element)
            }
          })
        })
    },
    getNamesClient() {
      this.axios
        .post(
          'reservations/names-client',
          { type: 'reservas' },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
            },
          },
        )
        .then(res => {
          if (res.data.success) {
            this.names = res.data.data.names
          }
        })
    },
    getCodesReservas() {
      this.axios
        .post(
          'reservations/codes-reservas',
          { type: 'reservas' },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
            },
          },
        )
        .then(res => {
          if (res.data.success) {
            this.codes = res.data.data.codes
          }
        })
    },
    getAfiliados() {
      this.axios
        .post(
          'reservations/afiliados-reservas',
          { type: 'reservas' },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
            },
          },
        )
        .then(res => {
          if (res.data.success) {
            this.afiliadosList = res.data.data.afiliados
          }
        })
    },
    getSeller() {
      this.axios
        .post(
          'reservations/seller-reservas',
          { type: 'reservas' },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
            },
          },
        )
        .then(res => {
          if (res.data.success) {
            this.sellerList = res.data.data.seller
          }
        })
    },
    getReservas() {
      this.openFiltros = false
      const json = {
        page: this.pagination.current,
        per_page: this.itemsPerPage,
        type: 'reservas',
        search: this.search,
      }
      this.axios
        .post('reservations/list', json, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          if (res.data.success === false) {
            // this.$toast.error(this.$t('msg.noAutorice'))
            // this.$store.commit('logout')
          } else {
            // console.log(res)

            this.reservas = res.data.data

            this.pagination.current = res.data.meta.current_page
            this.pagination.total = res.data.meta.last_page

            this.totalF = res.data.meta.total
          }
        })
    },
    getCotizations() {
      this.openFiltros = false
      const json = {
        page: this.paginationCotization.current,
        per_page: this.itemsPerPage,
        type: 'cotization',
        search: this.search,
      }
      this.axios
        .post('reservations/list', json, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          if (res.data.success === false) {
            // this.$toast.error(this.$t('msg.noAutorice'))
            // this.$store.commit('logout')
          } else {
            // console.log(res)

            this.cotizations = res.data.data

            this.paginationCotization.current = res.data.meta.current_page
            this.paginationCotization.total = res.data.meta.last_page

            this.totalFCotization = res.data.meta.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    changeCantItems() {
      if (this.pos === 0) {
        this.getReservas()
      } else {
        this.getCotizations()
      }
    },
    searchAll() {
      this.pagination.current = 1
      if (this.pos === 0) {
        this.getReservas()
      } else {
        this.getCotizations()
      }
    },
    getReservasAll() {
      const json = {
        page: this.pagination.current,
        type: 'reservas',
        per_page: 1000,
        search: this.search,
      }
      this.axios
        .post('reservations/list', json, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          // eslint-disable-next-line no-empty
          if (res.data.success === false) {
          } else {
            this.totalItems = res.data.meta.total
          }
        })
    },
    getCotizationsAll() {
      const json = {
        page: this.paginationCotization.current,
        type: 'cotization',
        per_page: 1000,
        search: this.search,
      }
      this.axios
        .post('reservations/list', json, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          // eslint-disable-next-line no-empty
          if (res.data.success === false) {
          } else {
            this.totalItemsCotization = res.data.meta.total
          }
        })
    },
    onPageChange() {
      if (this.pos === 0) {
        this.getReservas()
      } else {
        this.getCotizations()
      }
    },
    reseat() {
      this.isDialogVisible = false
      this.isDialogVisibleDelete = false
      this.item = {}
      this.itemId = null
      this.loading = false
      this.loadAll()
    },
    loadAll() {
      this.getReservas()
      this.getCotizations()
    },
    initAll() {
      this.getReservas()
      this.getReservasAll()
      this.getCotizations()
      this.getCotizationsAll()
    },

    clearSearch() {
      this.search = {}
      this.loadAll()
    },
  },
}
</script>

<style lang="scss" scoped>
.table-kitchen-sink ::v-deep {
  .v-data-table-header {
    white-space: nowrap;
  }
}
</style>
